import { numberSymbols } from "@progress/kendo-angular-intl";
import { Surface, Path, Text, Group, geometry } from "@progress/kendo-drawing";
const { transform } = geometry;

export function drawScene(surface: Surface, steps: any[]) {
  console.log(steps)
  // Create a path and draw a straight line
  const path = new Path({
    stroke: {
      color: `#7f8080`,
      width: 2,
    },
  });
  path.moveTo(0, 0);
  const gaugeLenth: number = 100;
  const individualStepLength: number = (gaugeLenth / steps.length)
  steps.forEach(element => {
    if(element.number===1)
    {
      path.lineTo(0, individualStepLength);
    }
    else{
      path.lineTo(0 + (-3 * (element.number-1)),(individualStepLength * element.number));
    }
    if((element.number) < steps.length && steps.length !== 1)
      path.lineTo(-3 * element.number, individualStepLength * element.number);
    else
      path.lineTo(-30, 125);
  });
  path.lineTo(-30,0).close().fill('#7f8080');
  const group = new Group();
  // Place all the shapes in a group 
  group.append(path);

  steps.forEach(element => {
    if(element.number===1 && steps.length !== 1)
    {
      const text = new Text((Math.round(element.length * 32) / 32) + '" X ' + (element?.exposure?.toFixed(3) <= 0 ? 'Full Gauge' : element?.exposure?.toFixed(3) + 'r') , [10 + (-3 * element.number), 0], {
        font: `bold 12px Arial`,
      });
      group.append(text);
    }
    else if(element.number===1 && steps.length === 1){
      const text = new Text((Math.round(element.length * 32) / 32) + '" X ' + (element?.exposure?.toFixed(3) <= 0 ? 'Full Gauge' : element?.exposure?.toFixed(3) + 'r'), [10 + (-3 * element.number), (individualStepLength * element.number) / 2], {
        font: `bold 12px Arial`,
      });
      group.append(text);
    }
    else{
      const text = new Text((Math.round(element.length * 32) / 32) + '" X ' + element?.exposure?.toFixed(3) + 'r', [10 + (-3 * element.number), individualStepLength * (element.number-1)], {
        font: `bold 12px Arial`,
      });
      group.append(text);
    }
  });
  // Create the text
  


  group.transform(transform().translate(50,0));
  

  // Render the group on the surface
  surface.draw(group);
}